import qs from 'qs'
import axios from './../index'

/**
 * @description 首页加载
 * http://192.168.2.177:3000/project/21/interface/api/1483
 * @author cc
 * @date 2019-11-2
 * @export
 */
export function loadIndex (params) {
  return axios.post('/home/load-index', qs.stringify(params))
}
/**
 * @description 加载新闻数据
 * @author cc
 * @date 2019-11-4
 * @export
 */
export function loadNews (params) {
  return axios.post('/home/load-news', qs.stringify(params))
}
/**
 * @description 加载新闻下方的数据
 * @author cc
 * @date 2019-11-4
 * @export
 */
export function activityIndexshow (params) {
  return axios.post('/home/activityindexshow', qs.stringify(params))
}
/**
 * @description 限时秒杀，今日特价，促销套餐，采满有赠，活动专区，数据
 * @author cc
 * @date 2019-11-4
 * @export
 */
export function sp (params) {
  return axios.post('/home/sp', qs.stringify(params))
}
/**
 * @description 为你推荐数据
 * @author cc
 * @date 2019-11-6
 * @export
 */
export function tuiJian (params) {
  return axios.post('/home/tui-jian', qs.stringify(params))
}
/**
 * @description 多批号
 * @author cc
 * @date 2019-11-9
 * @export
 */
export function selectBatchBuy (params) {
  return axios.post('/home/select-batch-buy', qs.stringify(params))
}
/**
 * @description 多批号的开启，小数点保留的位数，是否区域经销
 * @author cc
 * @date 2019-11-11
 * @export
 */
export function loadSetting () {
  return axios.post('/system/load-setting')
}
/**
 * @description 实时购物车数量
 * @author cc
 * @date 2019-11-13
 * @export
 */
export function getnum (params) {
  return axios.post('/cart/getnum/', qs.stringify(params))
}
/**
 * @description 活动提醒城市获取
 * @author cc
 * @date 2019-11-13
 * @export
 */
export function activity (params) {
  return axios.get('/json/activity', { params })
}
